import ReplaceText from 'core/display/composite/ReplaceText'
import { signal } from 'services/SignalsService'

export default class FreespinsAddText extends ReplaceText{
  constructor(data) {
    super(data)

    signal.on('STATE:IN:FS-START', this.update.bind(this))
    signal.on('STATE:IN:FS-ADD', this.update.bind(this))
  }

  update() {
    this.replace(game.models.FreespinModel.get().add)
  }
}
